const lang = {
    'headline': 'Gogoro® 隱私權及 Cookie 政策',
    'updated': [
        '最後更新日：2021 年 5 月 17 日'
    ],
    'privacy': {
        'subheading': '隱私權政策',
        'summary': [
            '英屬開曼群島商 Gogoro Inc. 及其關係企業與／或子公司、（以下合稱「Gogoro」、「Gogoro 集團」或「我們」）非常重視您的隱私權，故制定本隱私權政策（以下稱「Gogoro 隱私權政策」）以保護在您使用 Gogoro 網站（以下稱「本網站」）時，我們所取得的資訊。以下詳述 Gogoro 集團將如何蒐集、處理、儲存、利用，以及在某些情況下揭露、分享、移轉您的個人資訊與非個人資訊。您瞭解並同意當您使用本網站的同時，即視為您未拒絕且同意接受 Gogoro 隱私權政策所述內容。',
        ],
        'sections': [{
            'title': '本人已詳閱並充分瞭解 Gogoro 隱私權政策所述內容，並同意及授權 Gogoro 集團依此為本人個人資料之蒐集、處理、利用。',
        }, {
            'title': '本人充分瞭解 Gogoro 於提供服務之過程中，將不可避免地接受不具備個人識別性之相關資訊，包括但不限於 Gogoro Network® 智慧電池使用時間、使用里程、地理位置、即時定位等（下稱「使用資訊」），本人同意及授權 Gogoro 集團蒐集使用上述不具備個人識別性之資訊，或是將其與具可識別性之個人資料連結後一併蒐集與使用，並供 Gogoro 集團、 Gogoro 集團之關係企業，或受 Gogoro 集團委託或與 Gogoro 集團具有合作關係之第三方，於所在國家或地區為處理或利用，或供政府機關、公益團體或學術機構，於所在國家或地區，基於學術研究用途或公益目的處理或利用。',
        }, {
            'title': '本人同意 Gogoro 集團有權修訂 Gogoro 隱私權政策內容，並同意 Gogoro 集團於修訂後，得以言詞、書面、電話、簡訊、電子郵件、傳真、電子文件或其他足以使本人知悉或可得知悉之方式（包括但不限於以前述方式提供詳載個資告知事項內容之網站連結），告知修訂內容。若 Gogoro 變更或更新 Gogoro 隱私權政策，Gogoro 將以載明更新版本生效日期的方式，讓您瞭解 Gogoro 隱私權政策的內容已有變更。 Gogoro 鼓勵您不時檢閱 Gogoro 隱私權政策，以確定您所提供的個人資訊將如何被利用。',
        }, {
            'title': '個人資料蒐集、處理、利用告知事項',
            'description': 'Gogoro 集團依據個人資料保護法第 8 條告知消費者（下稱「您」）下列事項：',
            'sections': [{
                'title': '個人資料蒐集之特定目的：',
                'description': 'Gogoro 集團蒐集個人資訊之特定目的包含：',
                'sections': [{
                    'description': '提供您與 Gogoro 集團往來之各項業務或服務；如您同意使用 Gogoro 集團所提供之某些服務，您的個人資料如地理位置資訊將以定位（含即時）方式取得，使用方式依照相關服務條款以及本同意書所述；',
                }, {
                    'description': '推薦與提供您 Gogoro 集團、與 Gogoro 集團具有合作關係之第三方之產品或服務等行銷目的；',
                }, {
                    'description': '將您的個人資料與 Gogoro 集團合作廠商所提供關於您的資訊相結合，或於合作目的之必要範圍內將您的個人資料提供予合作廠商；',
                }, {
                    'description': '依法定義務、依契約、類似契約關係或其他法律關係等，所為個人資料之蒐集、處理及利用，並依契約行使、主張權利或進行執行程序；',
                }, {
                    'description': 'Gogoro 集團之各公司營業登記項目或章程所定業務或其他法令所准許之各項目的；',
                }, {
                    'description': 'Gogoro 集團業務或營運管理需要之目的；',
                }, {
                    'description': '其他符合法務部頒布之「個人資料保護法之特定目的及個人資料之類別」之特定目的如下：',
                    'sections': [{
                        'description': '040 「行銷」',
                    }, {
                        'description': '063 「非公務機關依法定義務所進行個人資料之蒐集處理及利用」',
                    }, {
                        'description': '069 「契約、類似契約或其他法律關係事務」',
                    }, {
                        'description': '090 「消費者、客戶管理與服務」',
                    }, {
                        'description': '098 「商業與技術資訊」',
                    }, {
                        'description': '148 「網路購物及其他電子商務服務」',
                    }, {
                        'description': '152 「廣告或商業行為管理」',
                    }, {
                        'description': '154 「徵信」',
                    }, {
                        'description': '157 「調查、統計與研究分析」',
                    }, {
                        'description': '181 「其他經營合於營業登記項目或組織章程所定之業務」',
                    }]
                }]
            }, {
                'title': '個人資料蒐集之類別：',
                'description': 'Gogoro 集團所蒐集之個人資料類別，依據法務部頒布之「個人資料保護法之特定目的及個人資料之類別」，說明如下。惟 Gogoro 集團蒐集之個人資料類別可能不限於此（如地理位置、即時定位資料），仍以 Gogoro 集團與您往來之各項業務或服務所實際蒐集之個人資料為準。',
                'sections': [{
                    'description': '識別類 C001 至 C003（如姓名、住址、電話、電子郵件、身分證統一編號、信用卡號碼等）',
                }, {
                    'description': '特徵類 C011（如年齡、性別、出生年月日等）',
                }, {
                    'description': '家庭情形 C021、C023 及 C024（如結婚有無、子女、其他社會關係等）',
                }, {
                    'description': '旅行及其他遷徙細節 C034（如過去之遷徙、旅行細節、外國護照、居留證明文件及工作證照及工作證等相關細節等）',
                }, {
                    'description': '社會情況 C035、C036、C038 至 C040（如嗜好、消費模式、職業、駕駛執照、意外或其他事故及有關情形等）',
                }, {
                    'description': '教育、考選、技術或其他專業 C051 及 C052（如學歷、學校、證照等）',
                }, {
                    'description': '受僱情形 C061、C064 及 C068（僱主、前僱主、薪資等）',
                }, {
                    'description': '財務細節 C081 及 C093（如總收入、總所得、支付方式等）',
                }, {
                    'description': '健康與其他 C114 及 C115（如交通違規紀錄、裁判或行政處分之內容等）',
                }, {
                    'description': '用戶地理位置',
                }, {
                    'description': '用戶即時定位',
                }],
            }, {
                'title': '個人資料之處理與利用之期間、地區、對象及方式：',
                'sections': [{
                    'description': '期間：符合第 1 點特定目的存續期間及該存續期間屆滿後之合理期間，或相關法令規定或契約約定之期間。惟 Gogoro 保留縮短前述期間之權利。',
                }, {
                    'description': '地區：中華民國境內及下述 (3) 之對象所在國家或地區。',
                }, {
                    'description': '對象：Gogoro 集團、Gogoro 集團之關係企業，或受 Gogoro 集團委託為 Gogoro 集團或您的利益而蒐集、處理或利用個人資料之第三方，或與 Gogoro 集團具有合作關係之廠商，例如電動機車相關產品及服務業者、數據統計及分析業者、行銷公司、服務提供者。',
                }, {
                    'description': '方式：言詞、書面（實體紙本或電子檔形式）、電話、簡訊、電子郵件、傳真、電子文件、數位文件、其他合於當時科技之適當方式等，或任何符合相關法令規定或契約約定之方式。',
                }],
            }, {
                'title': '您的相關權利：',
                'description': '您依據個人資料保護法第 3 條，就自己之個人資料得行使下列權利：',
                'sections': [{
                    'description': '您得就 Gogoro 集團所蒐集且關於您的個人資料，以書面向 Gogoro 集團請求查詢、閱覽或製給複製本。',
                }, {
                    'description': '您得請求 Gogoro 集團就您的個人資料為補充、停止蒐集、處理、利用或對不正確資料為更正、刪除。',
                }, {
                    'description': '您如擬行使前述任一權利，請檢附相關證明文件寄至桃園市龜山區頂湖路 33 號，並向 Gogoro 集團提出書面請求。申請查詢、請求閱覽或製給複製本者，Gogoro 就該書面請求之決定，將於收到書面請求之次日起 15 日內以書面通知您。前述 15 日期間於必要時，得予再延長 15 日，Gogoro 集團並將以書面通知您該延長之決定。',
                }, {
                    'description': '申請補充或更正、停止蒐集、處理、利用及刪除者，Gogoro 就該書面請求之決定，將於收到書面請求之次日起 30 日內以書面通知您。前述 30 日期間於必要時，得予再延長 30 日，Gogoro 集團並將以書面通知您該延長之決定。',
                }, {
                    'description': '您如請求查詢或閱覽個人資料，請於收受 Gogoro 集團通知後於通知指定之期間內，至 Gogoro 集團通知指定之地點查詢或閱覽。如逾期未查詢或閱覽者，請向 Gogoro 集團重新提出書面請求。您請求查詢或請求閱覽個人資料或製給複製本時，Gogoro 集團得酌收必要費用。',
                }],
            }, {
                'title': '您亦得選擇不提供前述個人資料，惟您充分瞭解倘不提供時將有可能影響 Gogoro 集團提供各項業務或服務之即時性，以及能否提供各項業務或服務。',
            }],
        }, {
            'title': 'Gogoro 得蒐集、處理及利用的非個人資訊',
            'description': [
                '一旦您使用本網站或依本網站的指示行動，Gogoro 或 Gogoro 的策略夥伴即可利用某些技術來蒐集您的「非個人資訊」，來追蹤您在本網站的使用及活動情況。非個人資訊係指無法單獨用以辨識或直接聯想出特定個人的資訊，包含但不限於藉由或經由本網站所蒐集的資訊。',
                'Gogoro 隱私權政策並不限制 Gogoro 利用或揭露任何非個人資訊，且 Gogoro 可自行決定利用或揭露非個人資訊予 Gogoro 的策略夥伴。例如，非個人資訊得被用來提升對您使用行為的瞭解、知悉使用者使用本網站的哪些部分，以及促進並評估廣告的有效性。',
            ]
        }, {
            'title': '保護您的個人資訊',
            'description': [
                'Gogoro 將採取合理適當機制，以避免您所提供的個人資訊遭未經授權或非法的存取、利用、處理或修改，及避免前述個人資訊遭侵害或喪失。Gogoro 得使用第三方服務，以踐行前述合理適當機制。您需為自己選擇分享或提交至本網站公開場域（例如論壇或留言板）的個人資訊負責。',
                '儘管 Gogoro 採取合理步驟作為安全措施並加以改善，您瞭解並同意世上並無絕對完備且安全的系統或技術。若您發現本網站的任何漏洞，請寄發電子郵件至 support.tw@ridegoshare.com，或使用本網站以回報前述漏洞。',
            ]
        }, {
            'title': 'Gogoro 隱私權政策的變更',
            'description': [
                'Gogoro 得隨時變更 Gogoro 隱私權政策中的任何條款。若 Gogoro 變更或更新 Gogoro 隱私權政策，Gogoro 將以載明更新版本生效日期的方式，讓您瞭解 Gogoro 隱私權政策的內容已有變更。Gogoro 鼓勵您不時檢閱 Gogoro 隱私權政策，以確定您所提供的個人資訊將如何被利用。',
            ]
        }]
    },
    'cookie': {
        'subheading': 'Cookie 政策',
        'summary': [
            '英屬開曼群島商 Gogoro Inc. 及其關係企業與/或子公司（包括但不限於英屬開曼群島商睿能新動力股份有限公司台灣分公司、睿能創意股份有限公司、 睿能創意營銷股份有限公司、睿能數位服務股份有限公司、睿能數位金融股份有限公司等）（以下合稱「Gogoro」、「Gogoro 集團」或「我們」），非常重視您的隱私權，並認為必須以清楚、透明之方式告知您有關您於 Gogoro 相關網站上瀏覽時網站 Cookies 之使用情形。',
        ],
        'sections': [{
            'title': ' ',
            'description': [
                'Cookies 是網站存儲在瀏覽者設備上一小部分之數據。我們可能於 Gogoro 相關網站使用下列一部或全部類型的 Cookies：'
            ],
            'sections': [{
                'title': '必要性 Cookies',
                'description': [
                    '這些 Cookies 讓您能夠在網站上進行瀏覽並使用網站之功能。如果沒有這些 Cookies，我們可能無法提供您需求之服務（例如：付款服務、帳戶授權等）。'
                ]
            }, {
                'title': '性能 Cookies',
                'description': [
                    '這些 Cookies 蒐集有關您如何使用網站之資訊，例如：您最常訪問哪些頁面等。這些 Cookies 不會蒐集可識別您的資料。這些 Cookies 蒐集之資料為匯總性之資料，故蒐集之資料亦有匿名性，主要用以改善網站功能及呈現方式等。'
                ]
            }, {
                'title': '功能性 Cookies',
                'description': [
                    '這些 Cookies 使網站可以記住用戶進行之選擇及填寫之內容（例如：用戶名、語言、所在地區等），並提供個人化功能。這些 Cookies 還可用於記住您對個人化網頁所進行之更改。它們也可以用來追蹤您已經查看過的通知，避免重複。這些 Cookie 蒐集之資料，並不會識別您的個人身份，也無法追蹤您在其他網站上的瀏覽活動。'
                ]
            }, {
                'title': '定位 Cookies 或廣告 Cookies',
                'description': [
                    '這些 Cookies 用於協助您接觸與您的興趣更為相關的廣告。它們還用於限制您看到廣告的次數，並有助於衡量廣告的有效性。它們通常是在網站運營商允許的情況下，由網絡廣告營運商所放置。它們將記住您訪問過的網站，並且以此資訊與其他組織（如：廣告商）共享。定位或廣告 Cookies 經常會連結到其他組織提供之網站。'
                ]
            }, {
                'title': '暫時性 Cookies',
                'description': [
                    '以上任何類別的 Cookies 都有可能是暫存型 Cookies，它們是臨時的，並且僅在訪問者關閉瀏覽器之前保留在您的設備上。'
                ]
            }, {
                'title': '持續或永久性 Cookies',
                'description': [
                    '以上任何一種 Cookies 類別都有可能是持續性 Cookies ，它將在設備上保留預定的時間，並在每次訪問者訪問網站時被應用。'
                ]
            }]
        }, {
            'title': 'Gogoro 網站使用之 Cookies',
            'description': [
                '我們可能會在您的設備上放置和存取某些 Cookies 。下列 Cookies 是我們直接放置，並由我們完全控制的 Cookies 。',
                'GoShare 網站（https://www.ridegoshare.com）無使用第一方 Cookie。',
            ]
        }, {
            'title': '使用第三方服務提供商',
            'description': [
                '除了上述 Cookies 外，您還可能會在您的設備上收到由我們以外的第三方服務提供商放置的某些第三方 Cookies 。第三方 Cookies 通常用於廣告相關目的。',
                '我們使用以下第三方服務提供商：',
                {
                    'style': 'third-party',
                    'head': [
                        'Cookie 名稱',
                        '目的及種類',
                        '是否必須',
                    ],
                    'body': [
                        [
                            'Google Analytics',
                            [
                                'Gogoro 使用 Google 分析瞭解網站行銷的效果和使用者與網站內容的互動，以此改善使用者造訪網站時的使用體驗。有時 Gogoro 會使用 Gogoro Analytics收集的數據提供一些更精準的廣告。',
                                'Cookie 保存期限：730天'
                            ],
                            '是'
                        ]
                    ]
                },
                {
                    'type': 'withLink',
                    'value':  '有關 Google Analytics（分析）的更多詳細資訊，請點擊%{here}以查閱 Google 的隱私權政策。',
                    'link': {
                        'here': {
                            'type': 'outside',
                            'value': '此處',
                            'style': 'cookie-link',
                            'href': 'https://policies.google.com/privacy?hl=zh-TW',
                        }
                    }
                }

            ]
        }, {
            'title': '同意 Cookies 蒐集',
            'description': [
                '使用本網站時，您即同意 Gogoro 得依上述方式處理您的個人資訊。您可以透過在瀏覽器上進行設定的方式，選擇不使用 Cookies，但請注意，一旦拒絕 Cookies，您可能無法使用本網站所有的功能。',
                '您可能會在下面找到有關如何修改瀏覽器設置/選項的相關資訊：'
            ],
            'sections': [
                {
                    'description': [
                        'Google Chrome:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.google.com/chrome/answer/95647?hl=en-GB',
                                    'style': 'cookie-link',
                                    'href': 'https://support.google.com/chrome/answer/95647?hl=en-GB',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Microsoft Internet Explorer:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.microsoft.com/zh-tw/windows/%E5%88%AA%E9%99%A4%E8%88%87%E7%AE%A1%E7%90%86-cookie-168dab11-0753-043d-7c16-ede5947fc64d',
                                    'style': 'cookie-link',
                                    'href': 'https://support.microsoft.com/zh-tw/windows/%E5%88%AA%E9%99%A4%E8%88%87%E7%AE%A1%E7%90%86-cookie-168dab11-0753-043d-7c16-ede5947fc64d',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Microsoft Edge:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.microsoft.com/en-gb/products/microsoft-edge',
                                    'style': 'cookie-link',
                                    'href': 'https://support.microsoft.com/en-gb/products/microsoft-edge',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Safari (macOS):',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.apple.com/zh-hk/guide/safari/welcome/14.0/mac/11.0',
                                    'style': 'cookie-link',
                                    'href': 'https://support.apple.com/zh-hk/guide/safari/welcome/14.0/mac/11.0',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Safari (iOS):',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.apple.com/zh-tw/HT201265',
                                    'style': 'cookie-link',
                                    'href': 'https://support.apple.com/zh-tw/HT201265',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Mozilla Firefox:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.mozilla.org/zh-TW/products/firefox/protect-your-privacy/cookies',
                                    'style': 'cookie-link',
                                    'href': 'https://support.mozilla.org/zh-TW/products/firefox/protect-your-privacy/cookies',
                                }
                            }
                        }
                    ],
                },
                {
                    'description': [
                        'Android:',
                        {
                            'type': 'withLink',
                            'value':  '%{doc}',
                            'link': {
                                'doc': {
                                    'type': 'outside',
                                    'value': 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en',
                                    'style': 'cookie-link',
                                    'href': 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=en',
                                }
                            }
                        }
                    ],
                }
            ]
        }, {
            'title': '變更',
            'description': [
                '我們可能會不時更改本 Cookie 政策。進行更改後，任何此類更改將在您首次使用我們網站時對您產生約束力。因此，建議您定期檢查此 Cookie 政策。'
            ]
        },{
            'title': '更多資訊',
            'description': [
                {
                    'type': 'withLink',
                    'value': '如果您對我們如何使用和保護 Cookies 以外的個人資料感興趣，請在%{here}找到我們的隱私政策。',
                    'link': {
                        'here': {
                            'type': 'inside',
                            'value': '此處',
                            'style': 'cookie-link',
                            'href': '/privacy',
                        }
                    }
                },
                '如果您對此 Cookie 政策有任何疑問，請通過 dataprivacy@gogoro.com 與我們聯繫。'
            ]
        }]
    },
    'copyright': [
        'Copyright © 2019-2021 Gogoro Inc. 著作權所有，並保留一切權利。',
    ],

};

export default lang;
